<template>
  <div v-if="!lock">

    <div class="edit-container">
      <router-link :to="{name: 'Promises'}">
        <i class="fal fa-edit"></i> 編集
      </router-link>
    </div>

    <div>
      <div v-for="(d, i) in data" :key="i" class="promise-add-container cursor-pointer" @click="addPay(d)">

        <div class="icon-container">
          <div class="icon-image">
            <img v-if="d.type == 1" src="/images/icn_yubikiri.svg">
            <img v-if="d.type == 2" src="/images/icn_gift.svg">
          </div>
          <div class="icon-info">
            <span v-if="d.type == 1">やくそく</span>
            <span v-if="d.type == 2">ごほうび</span>
          </div>
        </div>

        <div>
          <div class="detail-container">
            <div class="pay-box">
              {{d.pay}}<span class="pay">ペイ</span>
            </div>
            <div>
              <div class="title">
                {{d.title}}
              </div>
              <div class="detail">
                {{d.detail}}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-if="isNoData">
        <i class="fal fa-info-circle"></i> お約束はありません
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['isView', 'useEdit'],
  components: {},
  data () {
    return {
      store: 'promises',
      lock: false,
      data: {},
      show: false,
      id: null,
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }
    }
  },
  computed: {
    isNoData: function () {

      if (Object.keys(this.data).length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    initialize: function () {

      this.getList();

    },
    getList: function () {

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = {
        s: this.$store.getters['auth/session']
      };
      // console.log(params);

      // ロック
      this.lock = true;

      let dispatch = this.store + '/list';

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters[this.store + '/status'];

        if (status === 200) {

          this.data = this.$store.getters[this.store + '/list'];

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    },
    addPay: function (promise) {
      console.log('addPay', promise);

      this.$emit('promiseSuccess', promise);

    }

  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .edit-container {
    text-align: right;
    font-size: 12px;

    a {
      color: #78ACD7;
    }
  }

  .promise-add-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;

    .icon-container {
      width: 50px;
      text-align: center;
      position: relative;
      border: 1px solid $keyColor;
      border-radius: 6px;
      margin-right: 10px;

      .icon-image {
        img {
          width: 35px;
        }
        padding-bottom: 10px;
      }

      .icon-info {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        font-size: 10px;
      }
    }

  }

  // 801以上
  @media screen and (min-width: 801px) {
    .detail-container {
      display: flex;

      .pay-box {
        width: 140px;
        font-size: 25px;
        line-height: 40px;

        .pay {
          font-size: 12px;
        }
      }
    }

    .icon-container{
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .detail-container {
      .title {
        padding-top: 2px;
        line-height: 22px;
      }
      .detail {
        font-size: 13px;
      }
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {

    .promise-add-container{
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .pay-box {
      font-size: 18px;
      line-height: 22px;

      .pay {
        font-size: 12px;
      }
    }

    .detail-container {
      .title {
        line-height: 14px;
      }
      .detail {
        font-size: 13px;
      }
    }
  }

</style>
